import { useTranslation } from "react-i18next";
import Button from "../../ui/Button";
import AnimatedImages from "../../ui/AnimatedImageForm";
import { imageData2, imageData4 } from "../../utils/ImageData";

function LeftEquipment({
  images = [imageData2, imageData4],
  equipmentBlock1,
  equipmentBlock2,
  equipmentText,
  button,
  onLearnMore,
}) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col h-fit-content lg:flex-row items-center lg:items-start mb-[42vw] lg:mb-0 sm:mb-64 xl:mb-36 md:mb-64 2xl:mb-64">
      {/* Left Column: Text */}
      <div className="w-full lg:w-1/2 xs:px-6 mb-8 lg:mb-0 flex justify-start">
        <div className="flex items-start w-full">
          <div className="text-left">
            {/* Title Section */}
            <div className="flex items-center mb-10 xxs:px-2">
              <div className="min-w-3 self-stretch mt-2 bg-green-800 mr-4"></div>
              <h3 className="text-4xl font-semibold text-gray-700 leading-tight">
                <span className="block">{t(equipmentBlock1)}</span>
                <span className="block">{t(equipmentBlock2)}</span>
              </h3>
            </div>

            {/* Text Section */}
            <div className="flex">
              <p className="text-gray-600 mb-10 xxs:mx-2 xs:mx-0 leading-relaxed">
                {t(equipmentText)}
              </p>
            </div>

            {/* Button Section */}
            <Button
              className=""
              bgColor="bg-green-800"
              textColor="text-white"
              boxShadowColor="#15803d"
              onClick={onLearnMore}
            >
              {t(button)}
            </Button>
          </div>
        </div>
      </div>

      {/* Right Column: Image */}
      <div className="w-full mt-4 lg:w-1/2">
        <AnimatedImages images={images} />
      </div>
    </div>
  );
}

export default LeftEquipment;
